import React, { useState, useEffect } from 'react';
import { auth, db } from '../firebaseConfig';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc, getDocs, query, collection, where } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import './RegisterAdmin.css';
import { useTranslation } from 'react-i18next';

const RegisterAdmin = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [coffeeShopId, setCoffeeShopId] = useState('');
  const [coffeeShopName, setCoffeeShopName] = useState('');
  const [role, setRole] = useState('owner');
  const [pin, setPin] = useState('');
  const [message, setMessage] = useState('');
  const [currentUserRole, setCurrentUserRole] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchCurrentUserRole = async () => {
      const currentUser = auth.currentUser;
      if (!currentUser) return;

      const q = query(collection(db, 'admin_users'), where('email', '==', currentUser.email));
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        const userData = snapshot.docs[0].data();
        setCurrentUserRole(userData.role);
      }
    };

    fetchCurrentUserRole();
  }, []);

  const handleRegister = async (e) => {
    e.preventDefault();

    if (!username || !email || !password || !pin || !coffeeShopId || !coffeeShopName || !role) {
      setMessage(t('all_fields_required'));
      return;
    }

    if (role === 'system_admin' && currentUserRole !== 'system_admin') {
      setMessage(t('only_sysadmin_can_create'));
      return;
    }

    const userQuery = query(collection(db, "admin_users"), where("username", "==", username));
    const existingUser = await getDocs(userQuery);

    if (!existingUser.empty) {
      setMessage(t('username_exists'));
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;

      await setDoc(doc(db, "admin_users", userId), {
        username,
        email,
        coffee_shop_id: coffeeShopId,
        coffee_shop_name: coffeeShopName,
        role,
        pin
      });

        // 2️⃣ Create tenant entry (for public review page)
  await setDoc(doc(db, "tenants", coffeeShopId), {
    name: coffeeShopName,
    coffee_shop_id: coffeeShopId,
    public_listing: false, // default is hidden from public
    created_at: new Date()
  });

      setMessage(t('admin_created'));
      setTimeout(() => navigate('/dashboard'), 1500);
    } catch (error) {
      setMessage(t('registration_failed') + ' ' + error.message);
    }
  };

  return (
    <div className="register-container">
      <h2>{t('register_admin_title')}</h2>
      <form onSubmit={handleRegister}>
        <input type="text" placeholder={t('username')} value={username} onChange={(e)=>setUsername(e.target.value)} required/>
        <input type="email" placeholder={t('email')} value={email} onChange={(e)=>setEmail(e.target.value)} required/>
        <input type="password" placeholder={t('password')} value={password} onChange={(e)=>setPassword(e.target.value)} required/>
        <input type="password" placeholder={t('pin')} value={pin} maxLength={10} onChange={(e)=>setPin(e.target.value)} required/>
        <input type="text" placeholder={t('coffee_shop_id')} value={coffeeShopId} onChange={(e)=>setCoffeeShopId(e.target.value)} required/>
        <input type="text" placeholder={t('coffee_shop_name')} value={coffeeShopName} onChange={(e)=>setCoffeeShopName(e.target.value)} required/>
        
        <select value={role} onChange={(e)=>setRole(e.target.value)} required>
          {currentUserRole === 'system_admin' && <option value="system_admin">{t('system_admin')}</option>}
          <option value="owner">{t('owner')}</option>

          <option value="worker">{t('worker')}</option>
        </select>

        <button type="submit">{t('register_button')}</button>
        <button className="back-dashboard" onClick={() => navigate('/dashboard')} type="button">
          {t('back_dashboard')}
        </button>
      </form>
      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default RegisterAdmin;